import { useEffect, useRef } from 'react'

// Runs `onReset` each time `signal` changes (a counter bumped by the parent),
// but only if `shouldReset` is true at that moment. Used to take the user out
// of an open document when they click the already-active Documents tab.
export const useResetOnSignal = (
  signal: number,
  shouldReset: boolean,
  onReset: () => void
) => {
  const lastSignal = useRef(signal)

  useEffect(() => {
    if (signal === lastSignal.current) return
    lastSignal.current = signal
    if (shouldReset) onReset()
    // Only a new signal triggers a reset, never a change in the other inputs
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [signal])
}
